<template>
  <section>
    <div class="title-outer" data-reveal-text>
      <!-- <div class="left-line"></div> -->
      <div>
        <div :class="!isPortrait?'main-title':'main-title-mob'">{{ title }}</div>
        <div :class="!isPortrait?'sub-title':'sub-title-mob'">{{ subtitle }}</div>
      </div>
    </div>
    <div class="my-weiper-container" :class="{ 'my-weiper-container-mob': !isPC }">
      <div class="swiper-container" :class="'swiper-container' + id" :style ="!isPC?'height:auto':''">
        <div class="swiper-wrapper">
          <div class="swiper-slide" :class="{ 'swiper-slide-mob': !isPC }" v-for="(item, index) in imgs" :key="index">
            <div v-if="!isPortrait" class="slide-flex">
              <div>
                <div v-if="item.type == 'video'">
                  <video :src="isPC ? item.videoPc : item.videoMob" autoplay loop></video>
                </div>
                <div v-else>
                  <div class="imgBox">
                    <img class="swiper-lazy" :data-src="isPC ? item.imgPC : item.imgMob" alt="" :data-index="index">
                    <div class="swiper-lazy-preloader"></div>
                  </div>

                </div>
              </div>
              <div class="des">
                <div class="main">
                  <div class="title">{{ item.title }}</div>
                  <!-- <div class="text">{{ item.text }}</div> -->
                </div>
              </div>
            </div>
            <div v-else class="mob-s">
              <div v-if="item.type == 'video'">
                <video :src="isPC ? item.videoPc : item.videoMob" autoplay loop></video>
              </div>
              <div v-else>
                <div class="imgBox-mob" :class="'imgBox-mob' + id">
                  <img class="swiper-lazy" :data-src="isPC ? item.imgPC : item.imgMob" alt="" :data-index="index">
                  <div class="swiper-lazy-preloader"></div>
                </div>
              </div>
              <div id="des" class="des-mob">
                <div class="main-mob">
                  <div class="title-mob">{{ item.title }}</div>
                  <!-- <div class="text">{{ item.text }}</div> -->
                </div>
              </div>
              <!-- <div v-if="isPortrait" style="bottom: unset;" class="swiper-pagination" :class="'swiper-pagination' + id"></div> -->
            </div>
          </div>
        </div>
        <!-- <div class="swiper-pagination" :class="{ 'swiper-pagination-mob': !isPC }"></div> -->
        <div v-if="isPortrait" style="bottom: unset;top: calc(420 / 375 * 100vw);" class="swiper-pagination" :class="'swiper-pagination' + id"></div>
      </div>
      <div v-if="!isPortrait" class="swiper-pagination" :class="'swiper-pagination' + id"></div>
    </div>
  </section>
</template>
<script>
import Swiper from "swiper";
import { isPortraitFun, getUrlKey, isPc, maidian } from "@/utils/utils.js";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      isPC: isPc(),
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    imgs: {
      type: Array,
      default: []
    },
    id: {
      type: String,
      default: ''
    },
  },
  mounted() {
    document.querySelector("#des")
    console.log(this.id)
    var that = this
    var swiper = new Swiper('.swiper-container' + this.id, {
      pagination: {
        el: '.swiper-pagination' + this.id,
        clickable: true,
      },
      autoplay: false,
      loop: false,
      speed: 500,
      preloadImages: false,
      watchSlidesVisibility: true,
      lazy: {
        loadOnTransitionStart: true,
        loadPrevNext: true,
        loadPrevNextAmount: 1
      },
    });
    swiper.init();
    swiper.on('slideChange', function () {
      maidian(that.title + '-' + that.imgs[this.realIndex].title)
    });
  }
}
</script>
<style lang="scss" scoped>
.mob-s{
  height: 60%;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: space-evenly;
}
.swiper-slide-mob{
  height: 94vh;
  background-color: #fff;
}
.title-outer {
  display: flex;
  padding-left: calc(160/1920*100vw);
  padding-bottom: calc(120/1920*100vw);
  padding-top: calc(156/1920*100vw);

  .left-line {
    width: 0.208333vw;
    height: 2.1875vw;
    background: #3A88BC;
    opacity: 1;
    // border: 4px solid #3A88BC;
    margin-right: 2.708333vw;
  }

  .main-title {
    font-weight: 800;
    font-size: 2.083333vw;
    padding-bottom: 1.458333vw;
    line-height: 2.1875vw;
  }

  .main-title-mob {
    margin-top:calc(60 / 375 * 100vw);
    font-weight: 800;
    font-size: calc(22 / 375 * 100vw);
    padding-bottom: 1.458333vw;
    line-height: 2.1875vw;
  }

  .sub-title {
    // font-family: "heijian";
    font-size: calc(24/1920*100vw);
  }

  .sub-title-mob {
    // font-family: "heijian";
    font-size: calc(14/375*100vw);
    margin-top: calc(16 / 375 * 100vw);
  }
}

.my-weiper-container {
  width: 87.5vw;
  margin: 0 auto;

  .swiper-container {
    width: 100%;
    height: 39.195419vw;
    background: rgba(5, 20, 31, 0.03);

    video {
      width: 57.8125vw;
      height: 39.21875vw;
      object-fit: cover;
    }

    .imgBox {
      width: 57.8125vw;
      height: 39.21875vw;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .imgBox-mob{
      width: 100%;
      height: 100vw;
    }

    //ev5gtline-videopicstext-swiper
    .imgBox-mob11{
      width: 100%;
      height: 60vw;
    }

    .slide-flex {
      display: flex;
      justify-content: space-between;
    }

    .des {
      width: calc(630/1920*100vw);
      height: 36.4583vw;
      position: relative;

      .main {
        position: absolute;
        top: calc(583/1920*100vw);
        left: calc(30/1920*100vw);
      }
    }

    .title {
      font-size: calc(30/1920*100vw);
      color: #05141F;
      line-height: calc(56/1920*100vw);
      width: calc(450/1920*100vw);
      font-weight: 800;
      white-space: nowrap;
    }

    .text {
      font-size: calc(20/1920*100vw);
      color: rgba(5, 20, 31, 0.6);
      line-height: calc(32/1920*100vw);
      width: calc(450/1920*100vw);
    }
  }
  .swiper-container-mob{
    height: calc(328 / 375 * 100vw);
  }
}
.des-mob {
  // position: relative;
  // margin-top: 100px;
  .main-mob {
    text-align: center;
    // position: absolute;
    // top: calc(583/1920*100vw);
    // left: calc(114/1920*100vw);
  }
  .title-mob{
    color: #000;

  }
}

.swiper-pagination {
  left: 50%;
  transform: translateX(-50%);
  bottom: calc(153/1920*100vw);
  width: 100%;
}
.my-weiper-container-mob{
  .swiper-pagination11 {
    top: calc(270 / 375 * 100vw) !important;
  }
}

::v-deep .swiper-pagination-bullet {
  // margin-right:calc(5/1920*100vw);
  width: calc(36.5 / 1920 * 100vw);
  height: 1px;
  margin-right: 0.5vw;
  background-color: #000;

}

::v-deep .swiper-pagination-bullet-active {
  width: calc(76 / 1920 * 100vw);
  opacity: 1;
}</style>
